// extracted by mini-css-extract-plugin
export default {"container":"section_container__VJmdN","anchor":"section_anchor__litAk","title":"section_title__ogPtZ","hasLink":"section_hasLink__R7rAG"};